import React, { useEffect, useState } from 'react';
import { fetchContentAudit, formatSeoApiError } from '../../../utils/adminSeo';

export default function SeoContentAudit() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    setErr('');
    fetchContentAudit()
      .then(setData)
      .catch((e) => setErr(formatSeoApiError(e)));
  }, []);

  if (err) return <p className="text-red-600">{err}</p>;
  if (!data) return <p>Loading audit…</p>;

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-[#1B375B]">Content Quality Audit</h2>
      <p className="text-sm">
        Audited {data.audited} — flagged {data.flagged}
      </p>
      <div className="space-y-2 max-h-[70vh] overflow-y-auto">
        {(data.pages || []).map((p) => (
          <div key={p.page_id} className="border rounded-lg p-3 text-sm bg-white">
            <div className="font-medium">
              {p.page_type}/{p.slug}
              {p.entity_health_score != null && (
                <span className="ml-2 text-gray-500">health {p.entity_health_score}</span>
              )}
            </div>
            <ul className="mt-1 list-disc pl-5 text-gray-700">
              {(p.issues || []).map((i, idx) => (
                <li key={idx}>
                  <span className={
                    i.severity === 'critical' ? 'text-red-700' : i.severity === 'warning' ? 'text-amber-700' : ''
                  }
                  >
                    [{i.severity}] {i.message}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
